import bannerDetailsSymbols from "../symbols/bannerDetails";

const initialState = {
  data: [],
  loading: false,
  error: false,
};

export default function BannerDetailsSymbolsReducer(
  state = initialState,
  action: any
) {
  switch (action.type) {
    case bannerDetailsSymbols.GET_BANNER_DETAILS:
      return { ...state, loading: true, error: false };
    case bannerDetailsSymbols.GET_BANNER_DETAILS_SUCCESS:
      return {
        ...state,
        data: action.payload.Result,
        loading: false,
        error: false,
      };
    case bannerDetailsSymbols.GET_BANNER_DETAILS_FAILURE:
      return {
        ...state,
        data: [],
        loading: false,
        error: true,
      };
    case bannerDetailsSymbols.CLEAR_GET_BANNER_DETAILS:
      return {
        ...state,
        data: [],
        loading: false,
        error: false,
      };

    default:
      return state;
  }
}
